export default __webpack_public_path__ + "static/media/trevor-sears.14e443ff.jpg";